import React from 'react';
import classNames from 'classnames';
import { DEVICES_PAGE_TAB } from 'common/utils/constants';

import './DevicesPageTabsBar.css';

const DevicesPageTabsBar = (props) => {
  return (
    <div className="DevicesPageTabsBarContainer">
      <div
        className={classNames({
          DevicesPageTabsBar_SingleTab: true,
          DevicesPageTabsBar_Active: props.activeTab === DEVICES_PAGE_TAB.pivot,
          DevicesPageTabsBar_Inactive: props.activeTab !== DEVICES_PAGE_TAB.pivot
        })}
        onClick={() => props.tabOnClick(DEVICES_PAGE_TAB.pivot)}
      >
        Pivot 5G
      </div>
      <div
        className={classNames({
          DevicesPageTabsBar_SingleTab: true,
          DevicesPageTabsBar_Active: props.activeTab === DEVICES_PAGE_TAB.echo,
          DevicesPageTabsBar_Inactive: props.activeTab !== DEVICES_PAGE_TAB.echo
        })}
        onClick={() => props.tabOnClick(DEVICES_PAGE_TAB.echo)}
      >
        Echo 5G
      </div>
      <div
        className={classNames({
          DevicesPageTabsBar_SingleTab: true,
          DevicesPageTabsBar_Active: props.activeTab === DEVICES_PAGE_TAB.all,
          DevicesPageTabsBar_Inactive: props.activeTab !== DEVICES_PAGE_TAB.all
        })}
        onClick={() => props.tabOnClick(DEVICES_PAGE_TAB.all)}
      >
        All Devices
      </div>
    </div>
  );
};

export default DevicesPageTabsBar;
